/**
 * @generated SignedSource<<03acc82f94da75d257e83f00bb127696>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ZakekeEnvironment = "COMPOSER" | "CUSTOMIZER" | "UNKNOWN" | "VIEWER";
export type globalsOnlyNewUIQuery$variables = {
  environment: ZakekeEnvironment;
};
export type globalsOnlyNewUIQuery$data = {
  readonly sellerUserInterfaces: {
    readonly nodes: ReadonlyArray<{
      readonly isDefault: boolean;
      readonly userInterfaceId: number | null;
    } | null> | null;
  } | null;
};
export type globalsOnlyNewUIQuery = {
  response: globalsOnlyNewUIQuery$data;
  variables: globalsOnlyNewUIQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "environment"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "environment",
    "variableName": "environment"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefault",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userInterfaceId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "globalsOnlyNewUIQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SellerUserInterfacesConnection",
        "kind": "LinkedField",
        "name": "sellerUserInterfaces",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerUserInterface",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "globalsOnlyNewUIQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SellerUserInterfacesConnection",
        "kind": "LinkedField",
        "name": "sellerUserInterfaces",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SellerUserInterface",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "a75901e40a86b831a28d83c207d295ce",
    "id": null,
    "metadata": {},
    "name": "globalsOnlyNewUIQuery",
    "operationKind": "query",
    "text": "query globalsOnlyNewUIQuery(\n  $environment: ZakekeEnvironment!\n) {\n  sellerUserInterfaces(first: 1, environment: $environment) {\n    nodes {\n      isDefault\n      userInterfaceId\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f579f7deb60495759e13305613f9d5bc";

export default node;
